import { AddressDto } from "./address.dto";
import { CompanyPartnerDto } from "./company-partner.dto";
import { CompanyResponsibleDto } from "./company-responsible.dto";
import { ForeignAccountDataDto } from "./foreign-account-data.dto";
import { PersonDto } from './person.dto';
import { RelationshipPoliticallyExposedPersonDto } from "./relationship-exposed-person.dto";

export class UpdateUserDto {
    userId: string;
    personId: number;
    phoneNumber: string;
    email: string;
    firstName: string;
    lastName: string;
    politicallyExposedPerson: boolean;
    address: AddressDto;
    foreignAccountData: ForeignAccountDataDto;
    relationshipPoliticallyExposedPerson: RelationshipPoliticallyExposedPersonDto;
    companyResponsibles: CompanyResponsibleDto[];
    companyPartners: CompanyPartnerDto[];
    corporateAccountId: number;
    document: string;
    documentFile: string;
    resetKey: string;
    documentType: number;
    jobTitle: string;
    imageUrl: string;
    acceptedTerms: boolean;
    hasCompanyControl: boolean;
    isPEP: boolean;
    /**
     *
     */
    constructor(
        person: PersonDto
    ) {
        const keys = Object.keys(person);
        for(var i =0, t = keys.length; i < t; i++) {
            const propName = keys[i];

            this[propName] = person[propName];
        }
        this.email = person.user.email;
        this.phoneNumber = person.user.phoneNumber;
        this.personId = person.id;
        this.userId = person.user.id

    }
}
